import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { ActionsService } from '../../services';
import { FormatHelper } from '../../helpers';
import ActionForm from './action_form';
import { Message } from '../Message';

@connect(state => {
  return {
    me: state.user.me
  }
})
class ActionAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      action: null,
      localErrorMessage: null
    };
  }

  handleSubmit({ name, description, actionResults }) {
    const translatedActionResults = actionResults.map(actionResult => {
      if (actionResult.type.actionResultType.isRoleBased) {
        return ({
          id: actionResult.id,
          role: { id: actionResult.value.value },
          actionResultType: { id: actionResult.type.actionResultType.id }
        });
      } else if (actionResult.locale) {
        return ({
          id: actionResult.id,
          value: actionResult.type.actionResultType.token === 'ad_hoc_sms' ? FormatHelper.formatPhoneNumber(actionResult.value) : actionResult.value,
          actionResultType: { id: actionResult.type.actionResultType.id },
          locale: actionResult.locale.value
        });
      } else {
        return ({
          id: actionResult.id,
          value: actionResult.value,
          actionResultType: { id: actionResult.type.actionResultType.id }
        })
      }
    });

    const action = {
      enterprise: { id: this.props.me.enterprise.id },
      name: name,
      description: description,
      actionResults: translatedActionResults
    };

    ActionsService.add(action).then(response => {
      this.setState({ action: response.action });
    }).catch(error => {
      const errorMessage = error.response && error.response && error.response.data && error.response.data.genericSystemErrorMessage ? error.response.data.genericSystemErrorMessage : 'Error with action add.';
      this.setState({ localErrorMessage: errorMessage });
      console.error(error);
    });
  }

  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
        <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    return null;
  }

  render() {

    if (this.state.action) {
      return (
          <Redirect to={{
            pathname: '/config/actions',
            state: {
              successMessage: i18next.t('messages.action-saved')
            }
          }}/>
      );
    } else if(this.props.me) {
      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={i18next.t('pages.actions.add-action')}
                         backLinkWithParams={{
                           link: {
                             pathname: "/config/actions",
                             search: backLinkSearch
                           }
                         }} />
            </div>
            {this.renderMessages()}

            <ActionForm onSubmit={this.handleSubmit.bind(this)}
                        backLinkWithParams={{
                          link: {
                            pathname: "/config/actions",
                            search: backLinkSearch
                          }
                        }}/>
          </div>
      );
    } else {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    }
  }
}

export default ActionAdd;
